export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

export const ENDPOINTS = {
  WORKKARD: {
    GET_DETAIL: {
      url: '/api/workkard/:id',
      method: HTTP_METHODS.GET,
      description: 'Get workkard detail by ID',
    },
    GET_MASTER_DATA: {
      url: '/api/workkard/masterdata',
      method: HTTP_METHODS.POST,
      description: 'Get workkard master data',
    },
    GET_LIST: {
      url: '/api/workkard/list',
      method: HTTP_METHODS.POST,
      description: 'Get workkard list with filters',
    },
    CREATE: {
      url: '/api/workkard',
      method: HTTP_METHODS.POST,
      description: 'Create new workkard',
    },
    UPDATE: {
      url: '/api/workkard/:id',
      method: HTTP_METHODS.PUT,
      description: 'Update workkard',
    },
    CLOSE: {
      url: '/1.0/workkard/close/:id',
      method: HTTP_METHODS.POST,
      description: 'Close workkard',
    },
    REOPEN: {
      url: '/api/workkard/:id/reopen',
      method: HTTP_METHODS.POST,
      description: 'Reopen workkard',
    },
    ARCHIVE: {
      url: '/api/workkard/:id/archive',
      method: HTTP_METHODS.POST,
      description: 'Archive workkard',
    },
    CHANGE_SPONSOR: {
      url: '/api/workkard/:id/sponsor',
      method: HTTP_METHODS.PUT,
      description: 'Change workkard sponsor',
    },
    GET_WATCHERS: {
      url: '/api/workkard/:id/watchers',
      method: HTTP_METHODS.GET,
      description: 'Get workkard watchers',
    },
    ADD_WATCHER: {
      url: '/api/workkard/:id/watchers',
      method: HTTP_METHODS.POST,
      description: 'Add workkard watcher',
    },
  },
  ACTIVITY: {
    GET_DETAIL: {
      url: '/api/activity/:id',
      method: HTTP_METHODS.GET,
      description: 'Get activity detail by ID',
    },
    GET_LIST: {
      url: '/api/activity/list',
      method: HTTP_METHODS.POST,
      description: 'Get activity list with filters',
    },
    CREATE: {
      url: '/api/activity',
      method: HTTP_METHODS.POST,
      description: 'Create new activity',
    },
    UPDATE: {
      url: '/api/activity/:id',
      method: HTTP_METHODS.PUT,
      description: 'Update activity',
    },
    CLOSE: {
      url: '/api/activity/:id/close',
      method: HTTP_METHODS.POST,
      description: 'Close activity',
    },
    REOPEN: {
      url: '/api/activity/:id/reopen',
      method: HTTP_METHODS.POST,
      description: 'Reopen activity',
    },
    COMPLETE: {
      url: '/api/activity/:id/complete',
      method: HTTP_METHODS.POST,
      description: 'Complete activity',
    },
    ACCEPT: {
      url: '/api/activity/:id/accept',
      method: HTTP_METHODS.POST,
      description: 'Accept activity',
    },
    REJECT: {
      url: '/api/activity/:id/reject',
      method: HTTP_METHODS.POST,
      description: 'Reject activity',
    },
    REASSIGN: {
      url: '/api/activity/:id/reassign',
      method: HTTP_METHODS.POST,
      description: 'Reassign activity',
    },
  },
  DIARY: {
    GET_LIST: {
      url: '/api/diary/list',
      method: HTTP_METHODS.POST,
      description: 'Get diary list',
    },
    CREATE: {
      url: '/api/diary',
      method: HTTP_METHODS.POST,
      description: 'Create diary entry',
    },
    UPDATE: {
      url: '/api/diary/:id',
      method: HTTP_METHODS.PUT,
      description: 'Update diary entry',
    },
    DELETE: {
      url: '/api/diary/:id',
      method: HTTP_METHODS.DELETE,
      description: 'Delete diary entry',
    },
  },
  NOTE: {
    GET_LIST: {
      url: '/api/note/list',
      method: HTTP_METHODS.POST,
      description: 'Get notes list',
    },
    CREATE: {
      url: '/api/note',
      method: HTTP_METHODS.POST,
      description: 'Create note',
    },
    UPDATE: {
      url: '/api/note/:id',
      method: HTTP_METHODS.PUT,
      description: 'Update note',
    },
    DELETE: {
      url: '/api/note/:id',
      method: HTTP_METHODS.DELETE,
      description: 'Delete note',
    },
  },  
  FILE: {
    GET_LIST: {
      url: '/api/file/list',
      method: HTTP_METHODS.POST,
      description: 'Get files list',
    },
    UPLOAD: {
      url: '/api/file/upload',
      method: HTTP_METHODS.POST,
      description: 'Upload file',
    },
    DELETE: {
      url: '/api/file/:id',
      method: HTTP_METHODS.DELETE,
      description: 'Delete file',
    },
  },
  PARTY: {
    GET_LIST: {
      url: '/api/party/list',
      method: HTTP_METHODS.POST,
      description: 'Get parties list',
    },
    CREATE: {
      url: '/api/party',
      method: HTTP_METHODS.POST,
      description: 'Create party',
    },
    UPDATE: {
      url: '/api/party/:id',
      method: HTTP_METHODS.PUT,
      description: 'Update party',
    },
  },  
  RELATIONSHIP: {
    GET_LIST: {
      url: '/api/relationship/list',
      method: HTTP_METHODS.POST,
      description: 'Get relationships list',
    },
    CREATE: {
      url: '/api/relationship',
      method: HTTP_METHODS.POST,
      description: 'Create relationship',
    },
    UPDATE: {
      url: '/api/relationship/:id',
      method: HTTP_METHODS.PUT,
      description: 'Update relationship',
    },
  },
  USER: {
    GET_LIST: {
      url: '/api/user/list',
      method: HTTP_METHODS.POST,
      description: 'Get users list',
    },
    GET_DETAIL: {
      url: '/api/user/:id',
      method: HTTP_METHODS.GET,
      description: 'Get user detail',
    },
    CREATE: {
      url: '/api/user',
      method: HTTP_METHODS.POST,
      description: 'Create user',
    },
    UPDATE: {
      url: '/api/user/:id',
      method: HTTP_METHODS.PUT,
      description: 'Update user',
    },
  },
  SESSION: {
    GET_CONTEXT: {
      url: '/api/session/context',
      method: HTTP_METHODS.GET,
      description: 'Get session context',
    },
  },
  SEARCH: {
    GLOBAL: {
      url: '/api/search',
      method: HTTP_METHODS.POST,
      description: 'Global search',
    },
  }
};

export const getEndpoint = (domain, action) => {
  return ENDPOINTS[domain]?.[action] || null;
};

  export const buildUrl = (url, params = {}) => {
  let builtUrl = url;
  
  Object.keys(params).forEach((key) => {
    builtUrl = builtUrl.replace(`:${key}`, params[key]);
  });
  
  return builtUrl;
};

export default {
  ENDPOINTS,
  HTTP_METHODS,
  getEndpoint,
  buildUrl,
};
